var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ErrorLayout',{attrs:{"texto":_vm.textError,"titulo":'Erro no carregamento',"show-btn":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }